export const DEFAULT_DATA = {
  accounts: [
    { id: 1, name: 'Josh Fed Thrift (Alight)', owner: 'Josh', type: 'retirement', balance: 226215.48, lastUpdated: '2026-02-01' },
    { id: 2, name: 'Josh Roth IRA (eTrade)', owner: 'Josh', type: 'retirement', balance: 43834.39, lastUpdated: '2026-02-01' },
    { id: 3, name: 'Jenny Roth IRA (eTrade)', owner: 'Jenny', type: 'retirement', balance: 43569.33, lastUpdated: '2026-02-01' },
    { id: 4, name: 'Josh/Jenny Brokerage (eTrade)', owner: 'Joint', type: 'brokerage', balance: 22800.85, lastUpdated: '2026-02-01' },
    { id: 5, name: 'Jenny MN DCP', owner: 'Jenny', type: 'retirement', balance: 4367.36, lastUpdated: '2026-02-01' },
    { id: 6, name: 'Josh Upswing 401K (Ascensus)', owner: 'Josh', type: 'retirement', balance: 31499.42, lastUpdated: '2026-02-01' },
    { id: 7, name: 'Jenny Theraplay (Pacific Life)', owner: 'Jenny', type: 'retirement', balance: 8328.21, lastUpdated: '2026-02-01' },
    { id: 8, name: 'Jenny Alice (Equitable/LPL)', owner: 'Jenny', type: 'retirement', balance: 31644.01, lastUpdated: '2026-02-01' },
    { id: 9, name: 'Jenny Fairview (Fidelity)', owner: 'Jenny', type: 'retirement', balance: 71039.79, lastUpdated: '2026-02-01' },
    { id: 10, name: 'Jenny (Valic/AIGRS)', owner: 'Jenny', type: 'retirement', balance: 54824.42, lastUpdated: '2026-02-01' },
    { id: 11, name: 'Jenny People Inc (Lincoln)', owner: 'Jenny', type: 'retirement', balance: 12990.29, lastUpdated: '2026-02-01' },
    { id: 12, name: 'Jenny Thrivent', owner: 'Jenny', type: 'retirement', balance: 13753.22, lastUpdated: '2026-02-01' },
    { id: 13, name: 'Acorns', owner: 'Joint', type: 'brokerage', balance: 2688.46, lastUpdated: '2026-02-01' },
    { id: 14, name: 'Prosper', owner: 'Joint', type: 'other', balance: 693.08, lastUpdated: '2026-02-01' },
    { id: 15, name: 'Coinbase', owner: 'Joint', type: 'crypto', balance: 6343.07, lastUpdated: '2026-02-01' },
  ],
  retirementSettings: {
    targetYear: 2045,
    annualReturnLow: 6,
    annualReturnHigh: 10,
    currentAge: 45,
  },
  income: {
    jennyPension: 4487,
    joshFRBPension: 930,
    joshSS: 3009,
    jennySS: 3054,
    currentMonthlyInvestmentIncome: 1915.30,
  },
  contributions: [
    { id: 1, name: 'Jenny MN Monthly', amount: 210.00 },
    { id: 2, name: 'Josh Upswing Monthly', amount: 272.52 },
    { id: 3, name: 'Josh eTrade', amount: 173.33 },
    { id: 4, name: 'Jenny eTrade', amount: 173.33 },
  ],
  wheelTrades: {
    SOFI: [
      { id: 1, date: '2026-01-15', type: 'Put', strike: 18.50, expiration: 'Assigned', contracts: 1, premium: 210, outcome: 'Assigned', notes: 'Got assigned 534 shares' },
      { id: 2, date: '2026-03-03', type: 'Call', strike: 18.00, expiration: '2026-03-06', contracts: 5, premium: 267.41, outcome: 'Pending', notes: 'First covered call' },
    ],
    F: [],
  },
  wheelPositions: {
    SOFI: { shares: 534, costBasis: 18.50, targetShares: 500 },
    F: { shares: 0, costBasis: 0, targetShares: 500 },
  },
  historicalNetWorth: [
    { month: 'Oct 2025', value: 548000 },
    { month: 'Nov 2025', value: 556000 },
    { month: 'Dec 2025', value: 561000 },
    { month: 'Jan 2026', value: 568000 },
    { month: 'Feb 2026', value: 574591 },
  ],
  meditation: [],
};
